export const MENU_LIST_ITEM_CLASS_NAME =
  'relative left-0 flex w-full items-center transition-[left] duration-300';

export const LINK_CLASS_NAME =
  'flex w-full cursor-pointer items-center py-3 font-bold text-black';

export const SECONDARY_LINK_CLASS_NAME =
  'mb-[15px] flex w-full cursor-pointer items-center justify-center rounded-[10px] border border-grey-divide bg-white p-[5px] font-medium text-black';

export const SUBMENU_TRIGGER_CLASS_NAME = `${LINK_CLASS_NAME} text-left`;

export const LABEL_LINK_CLASS_NAME =
  'flex w-full cursor-pointer items-center py-3 font-normal text-grey-read';

export const ITEM_TEXT_CLASS_NAME =
  'h-full w-full whitespace-nowrap font-heading font-medium tracking-[0.4px]';

export const BRAND_LOGO_CLASS_NAME = 'mr-5';

export const BRAND_LOGO_IMAGE_CLASS_NAME =
  'mx-auto h-10 w-10 max-w-none object-contain';

function menuListVisibility(isShown: boolean, isExpanded: boolean) {
  if (isShown) return 'visible left-0 block';
  if (isExpanded) return 'invisible -left-[370px] block';

  return 'left-0 hidden';
}

export function menuListClassName({
  isExpanded,
  isShown
}: {
  isExpanded: boolean;
  isShown: boolean;
}) {
  return `absolute top-0 h-full w-full font-bold text-black transition-all duration-300 ${menuListVisibility(isShown, isExpanded)}`;
}
